module.exports = __webpack_public_path__ + "img/bg-tree.37cc7474.jpg";